<!--
 * @Version      : V1.0
 * @Date         : 2025-05-21 09:27:24
 * @fileName     :
 * @Description  : 我的开票
-->
<template>
  <div class="customerProfile-con px-20 py-20 border-box">
    <el-card class="box-card">
      <div class="query-con">
        <el-form :inline="true" :model="formInline" ref="ruleForm" class="demo-form-inline">
          <el-form-item label="收款合同名称" porp="contractReceivePaymentName">
            <el-input v-model="formInline.contractReceivePaymentName" placeholder="收款合同名称"></el-input>
          </el-form-item>
          <el-form-item label="项目类型" porp="projectName">
            <el-select clearable v-model="formInline.projectTypeCode" placeholder="请选择项目类型">
              <el-option v-for="item in projectOption" :key="item.id" :label="item.dictLabel" :value="item.dictValue">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户名称" porp="customerName">
            <el-input v-model="formInline.customerName" placeholder="客户名称"></el-input>
          </el-form-item>
          <el-form-item label="开票月份" porp="invoiceDateMoon">
            <el-date-picker clearable v-model="formInline.invoiceDateMoon" format="yyyy 年 MM 月" value-format="yyyy-MM"
              type="month" placeholder="请选择开票月份">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="查款到账月份" porp="checkedAndCreditedIntoAccountTimeMoon">
            <el-date-picker clearable v-model="formInline.checkedAndCreditedIntoAccountTimeMoon" format="yyyy 年 MM 月"
              value-format="yyyy-MM" type="month" placeholder="请选择查款到账月份">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryData">查询</el-button>
            <el-button @click="resetData('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <div class="operate py-20 border-box">
      <el-button type="success" @click="addItem()">新增</el-button>
      <!-- <el-button type="primary">导出</el-button>
      <el-button type="primary">导入</el-button> -->
    </div>
    <div class="table-con">
      <tableComponent :columns="columns" :tableData="dataList" @preSizeChange="childSizeChange"
        @preCurrentChange="childCurrentChange" :loading="loading" :pagination="pagination">

        <template #invoiceStatusSlot="{ row }">
          <div>
            <el-tag :type="formatterState(row.invoiceStatus, 'contract').type" effect="dark">{{
              formatterState(row.invoiceStatus, 'contract').text }}</el-tag>
          </div>
        </template>
        <template #ifCheckedAndCreditedIntoAccountSlot="{ row }">
          <div>
            <el-tag :type="row.ifCheckedAndCreditedIntoAccount == 0 ? 'danger' : 'success'" effect="dark">{{
              row.ifCheckedAndCreditedIntoAccount == 0 ? "否" : "是" }}</el-tag>
          </div>
        </template>
        <template #operate="{ row }">
          <div>
            <el-button type="text" @click="details(row)">开票详情</el-button>
            <el-button type="text" @click="reAdd(row)" v-if="row.invoiceStatus !== 0 && row.invoiceStatus !==9">重新发起</el-button>
            <el-button type="text" @click="withdraw(row)" v-if="row.invoiceStatus == 1">撤销</el-button>
            <el-button type="text" @click="edit(row)"
              v-if="row.invoiceStatus == 3 || row.invoiceStatus == 0 || row.invoiceStatus == 9">修改</el-button>
            <el-button type="text" @click="removeItem(row)" style="color:#F56C6C;"
              v-if="row.invoiceStatus == 0 || row.invoiceStatus == 9">删除</el-button>
          </div>
        </template>
      </tableComponent>
    </div>
    <my-contract-details ref="myComtractRefs" @initQueryData="queryData" :title="detailsT"
      :status="preStatus"></my-contract-details>
  </div>
</template>

<script>
import myContractDetails from './components/myContractDetails.vue'
import tableComponent from '@/components/tableComponent/index.vue'
import { formatterState } from '@/utils/index'
import { queryFinReceivedInvoiceApi, deleteFinReceivedInvoiceApi, withdrawFinReceivedInvoiceApi } from '@/api/finReceivedInvoiceItem/index'
import { dataPage } from "@/api/sys/dictData";
import dayjs from 'dayjs'
export default {
  components: {
    tableComponent,
    myContractDetails
  },
  data() {
    return {
      loading: false,
      dialogFormVisible: false,
      detailsT: '我的开票详情',
      formInline: {
        contractReceivePaymentName: "",
        projectTypeCode: "",
        customerName: "",
        invoiceDateMoon: "",
        checkedAndCreditedIntoAccountTimeMoon: ""
      },
      projectOption: [],
      dataList: [],
      preStatus: '',
      columns: [
        {
          id: 0,
          title: "序号", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "68px",
          keyName: "i", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        // {
        //   id: 2,
        //   title: "合同编号", // 标题名称
        //   isSort: false, // 是否展示排序按钮
        //   sortState: "",
        //   width: "180px",
        //   keyName: "correlationName", // 数据的属性值
        //   align: "left",
        //   slotName: "", // 插槽名,为空字符串时不使用
        // },
        {
          id: 4,
          title: "合同名称", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "120px",
          keyName: "contractReceivePaymentName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 5,
          title: "项目类型", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "projectTypeName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 6,
          title: "合同金额(元)", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "contractReceiveAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 26,
          title: "开票金额(元)", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "totalAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 27,
          title: "是否查款到账", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "ifCheckedAndCreditedIntoAccount", // 数据的属性值
          align: "center",
          slotName: "ifCheckedAndCreditedIntoAccountSlot", // 插槽名,为空字符串时不使用
        },
        {
          id: 28,
          title: "查款到账日期", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "150px",
          keyName: "checkedAndCreditedIntoAccountTime", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 7,
          title: "客户名称", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "120px",
          keyName: "customerName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 8,
          title: "开票单位", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "invoiceOwnerUnitName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 9,
          title: "开票类型", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "120px",
          keyName: "invoiceTypeName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 10,
          title: "预留开票时长(天)", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "invoiceReserveDays", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 11,
          title: "开票金额(元)", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "totalAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 12,
          title: "开票日期", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "invoiceDate", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },

        {
          id: 14,
          title: "提交人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "70px",
          keyName: "createByName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 15,
          title: "创建日期", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "145px",
          keyName: "createTime", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 16,
          title: "开票申请状态", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "invoiceStatus", // 数据的属性值
          align: "center",
          slotName: "invoiceStatusSlot", // 插槽名,为空字符串时不使用
        },
        {
          id: 17,
          title: "操作", // 标题名称
          fixed: "right",
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "150px",
          keyName: "", // 数据的属性值
          align: "left",
          slotName: "operate", // 插槽名,为空字符串时不使用
        }
      ],
      pagination: {
        pageCount: 7, //总页数
        total: 0, //总条目数
        pageSize: 1,//当前页条数
        pageSizes: [10, 20, 100]
      }
    }
  },
  mounted() {
    this.dictOption('project_type');
    let routeQuery = this.$route.query;
    // 获取本月 (格式: YYYY-MM)
    const currentMonth = dayjs().format('YYYY-MM');
    // 获取上个月 (格式: YYYY-MM)
    const previousMonth = dayjs().subtract(1, 'month').format('YYYY-MM');
    if ('month' in routeQuery) {
      this.formInline.invoiceDateMoon = routeQuery.month == 0 ? currentMonth : '';
      this.formInline.checkedAndCreditedIntoAccountTimeMoon = routeQuery.month == -1 ? previousMonth : '';
    }
    this.queryData()
  },
  methods: {
    formatterState,
    //查询
    queryData() {
      this.initData()
    },
    //初始化查询
    initData(item = {}) {
      let params = {
        pageNum: "1",
        pageSize: "10",
        query: {
          params: {
            contractReceivePaymentName: "",
            projectTypeCode: "",
            customerName: "",
            ...this.formInline
          },
          contractReceivePaymentId: "",//收款合同id
          invoiceTypeCode: "",//开票类型code 1 专票 字典 invoice_type
        },
        ...item
      }
      this.loading = true;
      queryFinReceivedInvoiceApi(params).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.dataList = res.data.rows;
          this.pagination.total = res.data.total;
        }
      })
    },
    childSizeChange(page) {
      this.initData({ pageSize: page })
    },
    childCurrentChange(value) {
      this.initData({ pageNum: value })
    },
    //重置搜索form
    resetData(formName) {
      this.formInline.contractReceivePaymentName = "";
      this.formInline.projectTypeCode = "";
      this.formInline.customerName = "";
      this.formInline.invoiceDateMoon = "";
      this.formInline.checkedAndCreditedIntoAccountTimeMoon = "";
      this.$nextTick(() => {
        this.initData()
      })
    },
    addItem() {
      this.preStatus = 'add'
      this.detailsT = '我的开票新增'
      this.$refs.myComtractRefs.openDrawer({})
    },
    details(row) {
      this.preStatus = 'view'
      this.detailsT = '我的开票详情'
      this.$refs.myComtractRefs.openDrawer(row)
    },
    edit(row) {
      this.preStatus = 'edit'
      this.detailsT = '我的开票编辑'
      this.$refs.myComtractRefs.openDrawer(row)
    },
    reAdd(row) {
      this.preStatus = 'reAdd'
      this.detailsT = '我的开票重新发起'
      this.$refs.myComtractRefs.openDrawer(row)
    },
    removeItem(row) {
      this.$confirm('确定要删除该开票？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.loading = true;
        deleteFinReceivedInvoiceApi({ id: row.id }).then(res => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: 'success'
            });
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
          this.loading = false;
          this.initData()
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    withdraw(row) {
      this.$confirm('确定要撤销该开票申请？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.loading = true;
        withdrawFinReceivedInvoiceApi({ id: row.id }).then(res => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: 'success'
            });
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
          this.loading = false;
          this.initData()
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    async dictOption(type) {
      let params = {
        query: {
          dictType: type
        }
      }
      dataPage(params).then(res => {
        if (res.code == 200) {
          this.projectOption = res.data.rows || []
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.customerProfile-con {
  background: #f7f4f4;

  .box-card {
    width: 100%;
  }

  .operate {}
}
</style>
